import { apiClient } from '../apiClient';

// Fire-and-forget page-view ping. A failed hit must NEVER disrupt navigation or trip the
// auth-logout response interceptor, so we pass skipAuthLogout and swallow every error.
export const recordPageHit = (path) => {
  if (!path || typeof path !== 'string') return Promise.resolve();
  return apiClient
    .post('/page-analytics/hit', { path }, { skipAuthLogout: true })
    .catch(() => {});
};

// Admin-only per-page usage rollup: [{ path, hits, uniqueUsers, lastSeen, firstSeen }].
export const getPageAnalyticsSummary = async () => {
  const res = await apiClient.get('/page-analytics/summary');
  return res.data;
};
